import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Facilities from "./pages/Facilities";
import Camps from "./pages/Camps";
import Team from "./pages/Team";
import Branches from "./pages/Branches";
import About from "./pages/About";
import Contact from "./pages/Contact";
import "./layout.css";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/facilities" element={<Facilities />} />
         <Route path="/camps" element={<Camps />} />
         <Route path="/team" element={<Team />} />
         <Route path="/branches" element={<Branches />} />
         <Route path="/about" element={<About />} />
         <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
